import {
	type OrderEmailNotificationCreateDto,
	postOrdersOrderIdEmails,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

interface Args {
	data: OrderEmailNotificationCreateDto;
	orderId: number;
}

export const useOrderEmailNotificationSend = () => {
	const { t } = useResource();

	return useMutation({
		mutationFn: processResponse((args: Args) =>
			postOrdersOrderIdEmails(args.data, args.orderId),
		),
		onError: (error) => {
			console.error(
				`${t(orderMutationsResource.orderEmailNotificationError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(orderMutationsResource.orderEmailNotificationSuccess));
		},
	});
};
